export default __webpack_public_path__ + "9103e94f1d34c15d44bedd10e1adb94c.svg";